
import React from 'react';
import {
    TextField,
} from '@material-ui/core';
import {Controller, useFormContext} from 'react-hook-form';

const Signature = ({name, onChange, onBlur, ...props}) => {
    const {control, errors} = useFormContext();

    return (
        <Controller
            render={p => (
                <TextField
                    {...props}
                    {...p}
                    fullWidth
                    error={!!errors[name]}
                    value={p.value?.user_text_input}
                    onChange={e => {
                        const newValue = {
                            user_text_input: e.target.value,
                            signed_dt: new Date(),
                        };

                        p.onChange(newValue)
                        onChange && onChange(newValue);
                    }}
                />
            )}
            control={control}
            name={name}
        />
    );
}

export default Signature;
